<template>
    <div
        class="modal fade"
        :id="`myModal${id}_2`"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="`myModalLabel${id}_2`"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" :id="`myModalLabel${id}_2`">
                        工作內容
                    </h4>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-hidden="true"
                    >
                        X
                    </button>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr class="tr-bg">
                                <th class="text-nowrap">交辦人</th>
                                <th class="text-nowrap">交辦內容</th>
                                <th class="text-nowrap">備忘錄</th>
                            </tr>
                        </thead>
                        <tbody class="tbody_hover">
                            <tr v-for="(list, i) in prelist" :key="i">
                                <td class="text-nowrap">
                                    <div
                                        v-for="(emp, j) in list.processing_emps"
                                        :key="j"
                                    >
                                        {{ emp.emp_name }}
                                    </div>
                                </td>
                                <td class="text-nowrap">
                                    {{ list.relations_todo_act_theme }}
                                </td>
                                <td class="text-nowrap">
                                    {{ list.relations_todo_memo }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn clear-btn"
                        data-dismiss="modal"
                    >
                        關閉
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        },
        prelist: {
            type: Array,
            default: () => []
        }
    }
};
</script>
